const Sortable = require('sortablejs').default;
require('summernote/dist/summernote-bs4.min.js');

function initSummernote() {
    const $content = $('#content');
    if (!$content.length || $content.hasClass('summernote-initialized')) {
        return;
    }

    // Check if summernote is loaded
    if (typeof $.fn.summernote === 'undefined') {
        return;
    }

    $content.summernote({
        height: 200,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['para', ['ul', 'ol']],
            ['insert', ['link']],
            ['view', ['codeview']]
        ],
        callbacks: {
            onChange: function(contents) {
                const wireEl = $content[0].closest('[wire\\:id]');
                if (wireEl && typeof Livewire !== 'undefined') {
                    Livewire.find(wireEl.getAttribute('wire:id')).set('content', contents);
                }
            }
        }
    });

    $content.addClass('summernote-initialized');
}

function initSortable() {
    document.querySelectorAll('.sortable-images').forEach(el => {
        // Skip if already initialized and has same number of items
        const currentItems = el.querySelectorAll('.image-item').length;
        if (el.sortableInstance && el.dataset.itemCount == currentItems) {
            return;
        }

        if (el.sortableInstance) {
            el.sortableInstance.destroy();
        }

        el.dataset.itemCount = currentItems;
        el.sortableInstance = new Sortable(el, {
            animation: 150,
            ghostClass: 'sortable-ghost',
            onEnd: function(evt) {
                const productIndex = parseInt(el.dataset.productIndex);
                const items = Array.from(el.querySelectorAll('.image-item'));
                const order = items.map(item => item.dataset.id);
                const wireEl = el.closest('[wire\\:id]');
                if (wireEl && typeof Livewire !== 'undefined') {
                    Livewire.find(wireEl.getAttribute('wire:id')).call('updateImageOrder', productIndex, order);
                }
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initSortable();
    initSummernote();
});

document.addEventListener('livewire:init', () => {
    initSortable();
    initSummernote();

    Livewire.hook('morph.updated', ({el, component}) => {
        setTimeout(initSortable, 50);
    });

    Livewire.on('images-updated', () => {
        setTimeout(initSortable, 150);
    });
});
